import { canUseDOM } from 'exenv';
import set from 'lodash/set';
import asyncMicYearPageAction from '../../../../redux/actions/mic/async_mic_year_page_actions';
import log from '../../../../services/logger_service';

export default function fetchDataWithStore(store, override) {
  return function fetchData(nextState, replace, callback) {
    const { dispatch } = store;

    if (override) {
      set(nextState, 'params.year', override);
    }

    // run async
    if (canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      asyncMicYearPageAction(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return asyncMicYearPageAction(nextState.params, store)(dispatch)
      .then(function cb() {
        if (callback) {
          return callback();
        }
        return false;
      })
      .catch(function handleActionError(error) {
        log.fatal(
          error,
          `Fatal error in onEnter state manager: ${error.message}`
        );
        if (callback) {
          return callback(error);
        }
        return false;
      });
  };
}
